/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const TAB_CONFIG = {
  provider: {
    id: 1,
    heading: "Select Provider",
  },
  data: {
    id: 2,
    heading: "Add Information",
  },
  summary: {
    id: 3,
    heading: "Summary",
  },
} as const;
